import { CopyToClipboardButton } from '@library/components/buttons';
import { cn } from '@library/component-utils/cn';

export interface CopyToClipboardCellProps {
  bannerMessage?: string;
  className?: string;
  dataTestId?: string;
  dataSentryMask?: boolean;
  label: string;
  textCopied: string;
}

export const CopyToClipboardCell = ({
  bannerMessage = 'Copied to Clipboard',
  className = 'flex flex-1 p-3',
  dataSentryMask = false,
  dataTestId = 'copy-to-clipboard-cell',
  label,
  textCopied
}: CopyToClipboardCellProps) => {
  return (
    <div
      className={cn('flex items-center', className)}
      data-testid={dataTestId}
    >
      <span
        className="text-2xs mr-2 leading-normal xl:text-xs"
        data-sentry-mask={dataSentryMask}
      >
        {label}
      </span>
      <CopyToClipboardButton
        bannerMessage={bannerMessage}
        iconClassName="group-hover/row:block hidden"
        textCopied={textCopied}
      />
    </div>
  );
};
